<template>
<!-- 建设端数据统计 -->
  <div class="total-box">
      <!-- <div class="total-head">数据统计表</div> -->
      <el-tabs v-model="activeName" @tab-click="handleClick"  style="height:calc(100% - 5vh)">
            <el-tab-pane  v-for="(item,index) in tabList" :key="index"  :label="item.name" :name="item.vlaue">
                <div class="total-main">
                    <div class="main-item" v-for="(item,index) in listData" :key="index">
                        <img :src="item.url" style="height:18vh;width:auto;cursor: pointer;" @click="toPage(item)" />
                        <p style="width:100%;height:4vh;position: relative;text-align: center;">{{item.name}}</p>
                    </div>
                </div>
            </el-tab-pane>
      </el-tabs>
      
  </div>
</template>

<script>
import util from '../../../untils/util'
export default {
    data(){
        return{ 
            activeName:'3',
            tabList:[{name:'数据统计表',vlaue:'3'},],
            listData:[
                // {name:'所有项目累计审定产值、支付、罚款汇总表 年 月 日',url:require('../../../assets/image/GX_swiper/total1.png'),href:'/formEnt'},
                // {name:'项目月产值、支付、罚款明细表',url:require('../../../assets/image/GX_swiper/total2.png'),href:'/form1'},
                // {name:'项目产值明细表',url:require('../../../assets/image/GX_swiper/total3.png'),href:'/form2'},
                // {name:'项目审定产值明细表',url:require('../../../assets/image/GX_swiper/total4.png'),href:'/form3'},
                // {name:'项目实际支付明细表',url:require('../../../assets/image/GX_swiper/total5.png'),href:'/form4'},
                // {name:'项目罚款明细表',url:require('../../../assets/image/GX_swiper/total6.png'),href:'/form5'},
                // {name:'项目专户支付明细表',url:require('../../../assets/image/GX_swiper/total7.png'),href:'/form6'},
                {name:'项目关键节点计划表',url:require('../../../assets/image/GX_swiper/total8.png'),href:'/form7'},
                {name:'项目关键节点实际完成情况表',url:require('../../../assets/image/GX_swiper/total9.png'),href:'/form8'},
            ],
            groupId:'',
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
    },
    methods:{
         handleClick(tab, event) {
        console.log(tab);
        if(tab.name==1){
            this.listData=[{name:'所有项目累计审定产值、支付、罚款汇总表 年 月 日',url:require('../../../assets/image/GX_swiper/total1.png'),href:'/formEnt'},]
        }else if(tab.name==2){
           this.listData=[ {name:'项目累计审定产值、支付、罚款汇总表  年  月  日',url:require('../../../assets/image/GX_swiper/total1.png'),href:'/form6'},]
        }else{
             this.listData=[
                //    {name:'项目合同月产值、支付、罚款明细表',url:require('../../../assets/image/GX_swiper/total6.png'),href:'/form1'},
                              {name:'项目关键节点计划',url:require('../../../assets/image/GX_swiper/total8.png'),href:'/form7'},
                              {name:'项目关键节点实际完成情况',url:require('../../../assets/image/GX_swiper/total9.png'),href:'/form8'},
             ]
        }
       },
        //跳转
        toPage(row){
            this.$router.push({path:row.href})
        },
    }
}
</script>

<style scoped>
    .total-box{
        width: 100%;
        height: 100%;
        position: relative;
        background: #fff;
        padding: 1vh;
    }
    .total-head{
        width: 100%;
        height: 5vh;
        position: relative;
        text-align: left;
        padding-left: 1vw;
        color: #409eff;
    }
    .total-main{
        width: 100%;
        height: calc( 100% - 5vh );
        position: relative;
        display: flex;
        justify-content: flex-start;
        justify-items: self-start;
        align-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        overflow: auto;
    }
    .main-item{
        width: 33%;
        height: 24vh;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        flex-wrap: wrap;
    }
    .total-box>>>.el-tabs--card>.el-tabs__header{
        height: 40px !important;
    }
    .total-box>>>.el-tabs__content {
        height: calc(100% - 55px)!important;
    }
</style>

<style>

</style>